import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import expertToplistQuery from './query.graphql';

const ExpertToplists = loadable(
  () => import(/* webpackChunkName: "expert" */ './toplists'),
  {
    fallback: <Loader />,
  }
);

ExpertToplists.graphQL = expertToplistQuery;

ExpertToplists.variables = ({ slug }) => ({
  slug,
});

export default ExpertToplists;
